import Base from "@/controllers/base";
export default class Web extends Base {
  constructor(elem) {
    super(elem);
  }

  shipmentTargetChanged(event) {
    let parent = document.querySelector("#track-shipments");
    parent.querySelectorAll("label.target").forEach((label) => label.hide());
    let target = document.querySelector("input[name='target']:checked").value;
    parent.querySelectorAll(`label.${target}`).forEach((label) => label.show());
  }
}
